import { render, staticRenderFns } from "./ColorList.vue?vue&type=template&id=76bbc0c6"
import script from "./ColorList.vue?vue&type=script&lang=ts"
export * from "./ColorList.vue?vue&type=script&lang=ts"
import style0 from "./ColorList.vue?vue&type=style&index=0&id=76bbc0c6&prod&lang=styl"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports